<!-- https://www.figma.com/file/hZ14djvbx5qYuIJwSU7moW/%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B-%F0%9F%94%A5?node-id=7%3A8621 -->
<template>
  <div
    v-if="articles.length"
    class="tv"
  >
    <AccentCard
      v-for="(article, index) of slicedArticles"
      :key="index"
      class="tv__card"
      :article="article"
      :size="sizes[index]"
      :inside-tv="true"
      :meta="meta"
      :image-loading="getImageLoading(index)"
      @click-article-link="sendAnalytics(article, index)"
    />
  </div>
  <div
    v-else
    class="tv-placeholder"
  >
    <AccentCardPlaceholder
      v-for="(article, index) in 4"
      :key="index"
      class="tv__card"
      :size="sizes[index]"
      :inside-tv="true"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import AccentCard from '~/components/AccentCard.vue';
  import AccentCardPlaceholder from '~/components/AccentCardPlaceholder.vue';
  import type { TArticle } from '~/types/common';
  import { TV_COUNT_ARTICLES, BREAKPOINTS } from '~/constants';
  import type { IMetaArchives } from '~/types/api/archives';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';
  import { useWindowStore } from '~/store/window';

  export default defineNuxtComponent({
    name: 'TV',

    components: {
      AccentCard,
      AccentCardPlaceholder,
    },

    inject: {
      eventCategory: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      articles: {
        type: Array as PropType<Array<TArticle>>,
        required: true,
      },

      meta: {
        type: Object as PropType<IMetaArchives>,
        default: null,
      },
    },

    computed: {
      windowWidth() {
        return useWindowStore().windowWidth;
      },

      slicedArticles(): TArticle[] {
        return this.articles.slice(0, TV_COUNT_ARTICLES);
      },

      sizes(): string[] {
        if (this.windowWidth < BREAKPOINTS.TABLET) {
          return ['big', 'small', 'small', 'small'];
        }

        if (this.windowWidth >= BREAKPOINTS.TABLET && this.windowWidth < BREAKPOINTS.DESKTOP) {
          return ['big', 'middle', 'small', 'small'];
        }

        return ['big', 'small', 'small', 'small'];
      },

      currentSlug(): string {
        return getSlugFromUrl(this.$route.fullPath);
      },
    },

    methods: {
      // Функция для аналитики выбора материала на главной
      sendAnalytics(_article: TArticle, _index: number) {
        // const eventElement =
        //   index === 0 ? 'Телевизор_большая карточка' : 'Телевизор_малые карточки';
        // const slugRefferer = getSlugFromUrl(article.url);
      },

      getImageLoading(index: number): 'lazy' | 'eager' | 'auto' {
        // eager для первых двух карточек, на мобилках видны только они. На десктопе частично все.
        return index === 0 || index === 1 ? 'eager' : 'auto';
      },
    },
  });
</script>

<style lang="scss" scoped>
  .tv,
  .tv-placeholder {
    background: black;
    padding: $spacing-4 $spacing-4 $spacing-8;
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: min-content;
    grid-row-gap: 12px;
    border-radius: 0;

    @include tablet {
      grid-template-areas: 'first first' 'second second' 'third fourth';
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: $spacing-3;
      padding: $spacing-6;
      border-radius: 48px;
    }

    @include big-tablet {
      padding: $spacing-8;
    }

    @include desktop {
      padding: $spacing-10;
      grid-template-areas: 'first first first' 'second third fourth';
      grid-template-columns: repeat(3, 1fr);
    }

    &__card {
      @include tablet {
        &:nth-child(1) {
          grid-area: first;
        }

        &:nth-child(2) {
          grid-area: second;
        }

        &:nth-child(3) {
          grid-area: third;
        }

        &:nth-child(4) {
          grid-area: fourth;
        }
      }
    }
  }
</style>
